/**
 * Campaign create wizard layout — Figma `4255:3898` (Create Campaign).
 *
 * **182dp** horizontal outside gap on AppShell `main` (`4255:3951` / `4255:3904` at x=182).
 * **32dp** vertical gutter + internal card padding unchanged.
 * Shell max width **896px** matches Figma stepper/body cards.
 */
/** Legacy cap — prefer full-width shell between AppShell gutters. */
export const CAMPAIGN_WIZARD_PAGE_MAX_WIDTH_PX = 1760

/** Horizontal inset from main content column edge to wizard cards (Figma `4255:3898`). */
export const CAMPAIGN_WIZARD_HORIZONTAL_OUTSIDE_GAP_PX = 182

/** Vertical inset on AppShell `main` (stepper top at y=32 within `CampaignWizard`). */
export const CAMPAIGN_WIZARD_VERTICAL_GUTTER_PX = 32

/**
 * @deprecated Prefer {@link CAMPAIGN_WIZARD_VERTICAL_GUTTER_PX} — kept for callers that used a single gutter token.
 */
export const CAMPAIGN_WIZARD_GUTTER_PX = CAMPAIGN_WIZARD_VERTICAL_GUTTER_PX

/** Stepper + body card width (Figma `4255:3951` / `4255:3904` w=896). */
export const CAMPAIGN_WIZARD_SHELL_MAX_WIDTH_PX = 896

/** Gap between stepper card and body card (Figma vertical rhythm). */
export const CAMPAIGN_WIZARD_STEPPER_TO_BODY_GAP_PX = 32

/** Stepper card (`4255:3951`) internal padding. */
export const CAMPAIGN_WIZARD_STEPPER_PADDING_PX = 25

/** Body card (`4255:3904`) padding — **32dp** on all breakpoints. */
export const CAMPAIGN_WIZARD_BODY_PADDING_X_PX = 32

export const CAMPAIGN_WIZARD_BODY_PADDING_Y_PX = 32

/** Figma `4255:3905` artboard form width — content stretches to body card (32dp pad), not a centered cap. */
export const CAMPAIGN_WIZARD_BODY_CONTENT_MAX_WIDTH_PX = 830

/** Main content canvas behind wizard cards (Figma `4255:3903` / handoff screenshots). */
export const CAMPAIGN_WIZARD_CANVAS_BG = '#f9fafb'

/** Stepper + body card fill — Figma `4255:3951` / `4255:3904` (`bg-white`). */
export const CAMPAIGN_WIZARD_CARD_BG = '#ffffff'

/** Card outline — Figma `border-[#e5e7eb]`. */
export const CAMPAIGN_WIZARD_CARD_BORDER = '#e5e7eb'
